import { MatchFilterOption } from '../sportsbook.models';

export const MATCH_FILTER_OPTIONS: readonly MatchFilterOption[] = [
  { id: 'all', label: 'All Matches', labelKey: 'filters.all' },
  { id: 'highlights', label: 'Highlights', labelKey: 'filters.highlights' },
  { id: 'live', label: 'Live Now', labelKey: 'filters.live', showLiveDot: true },
  { id: 'today', label: 'Today', labelKey: 'filters.today' },
  { id: 'tomorrow', label: 'Tomorrow', labelKey: 'filters.tomorrow' },
  { id: 'outrights', label: 'Outrights', labelKey: 'filters.outrights' }
];
